import React from 'react';

import * as Styled from './styled';

interface PropsType {
	stepsLength: number;
	activeStep: number;
	isStudent?: boolean;
}

function ChatRulesSteps({ stepsLength, activeStep, isStudent = true }: PropsType) {
	return (
		<Styled.Wrap>
			{Array.from({ length: stepsLength }).map((step, index) => (
				<Styled.Step isActive={index === activeStep} key={index} isStudent={isStudent}>
					{index + 1}
				</Styled.Step>
			))}
		</Styled.Wrap>
	);
}

export default ChatRulesSteps;
